import type { ComponentType } from "react";
import type { IconProps } from "../../ui/icons";
import {
  CheckSquare,
  BarChart3,
  ZapIcon,
  Flame,
  TrophyIcon,
  TargetIcon,
  Sun,
  MoonIcon,
} from "../../ui/icons";
import type { GamificationState } from "./store/gamification-store";

export interface Achievement {
  readonly id: string;
  readonly title: string;
  readonly description: string;
  readonly Icon: ComponentType<IconProps>;
  readonly progress?: (state: GamificationState) => { current: number; target: number };
}

export const ACHIEVEMENTS: readonly Achievement[] = [
  {
    id: "first_task",
    title: "Première tâche",
    description: "Compléter votre première tâche",
    Icon: CheckSquare,
    progress: (s) => ({ current: Math.min(s.tasksCompleted, 1), target: 1 }),
  },
  {
    id: "ten_tasks",
    title: "Productif",
    description: "Compléter 10 tâches",
    Icon: BarChart3,
    progress: (s) => ({ current: Math.min(s.tasksCompleted, 10), target: 10 }),
  },
  {
    id: "fifty_tasks",
    title: "Machine",
    description: "Compléter 50 tâches",
    Icon: ZapIcon,
    progress: (s) => ({ current: Math.min(s.tasksCompleted, 50), target: 50 }),
  },
  {
    id: "streak_7",
    title: "Régulier",
    description: "7 jours consécutifs",
    Icon: Flame,
    progress: (s) => ({ current: Math.min(s.loginStreak, 7), target: 7 }),
  },
  {
    id: "streak_30",
    title: "Inarrêtable",
    description: "30 jours consécutifs",
    Icon: TrophyIcon,
    progress: (s) => ({ current: Math.min(s.loginStreak, 30), target: 30 }),
  },
  {
    id: "habit_master",
    title: "Maître des habitudes",
    description: "100 habitudes complétées",
    Icon: TargetIcon,
    progress: (s) => ({ current: Math.min(s.habitsCompleted, 100), target: 100 }),
  },
  {
    id: "early_bird",
    title: "Lève-tôt",
    description: "Tâche complétée avant 8h",
    Icon: Sun,
  },
  {
    id: "night_owl",
    title: "Noctambule",
    description: "Tâche complétée après 22h",
    Icon: MoonIcon,
  },
];

export function getAchievementById(id: string): Achievement | undefined {
  return ACHIEVEMENTS.find((a) => a.id === id);
}
